import { CircularProgress } from "@mui/material";
import React from "react";

export default function FilledButton({
  IconFirst,
  iconFirstColor,
  text,
  textColor = "white",
  IconLast,
  iconLastColor,
  radius = "lg",
  bgColor = "primaryGreen",
  bgColorHover = "primaryGreenHover",
  showLoader = false,
  loaderColor = "white",
  btnClicked,
  btnType = null,
  isDisabled = false,
  padding = "3",
  width = "full",
  iconOnly = false,
  iconSize = "1",
}) {
  const getButtonClasses = () => {
    // Base classes with explicit width and padding
    const widthClass = width === 'full' ? 'w-full' : width === 'auto' ? 'w-auto' : `w-${width}`;
    const paddingClass = padding === '3' ? 'p-3' : padding === '2' ? 'p-2' : `p-${padding}`;
    const radiusClass = radius === 'lg' ? 'rounded-lg' : radius === 'md' ? 'rounded-md' : `rounded-${radius}`;
    
    let baseClasses = iconOnly
      ? `w-auto p-2 inline-flex items-center justify-center ${radiusClass} text-sm transition-colors duration-200`
      : `${widthClass} ${paddingClass} flex items-center justify-center gap-1 font-medium ${radiusClass} text-sm transition-colors duration-200`;
    
    if (isDisabled && !showLoader) {
      baseClasses += ' opacity-60 cursor-not-allowed';
    }
    
    // Background colors - always use white text for green and red buttons
    if (bgColor === 'primaryGreen') {
      baseClasses += ' bg-primaryGreen hover:bg-primaryGreenHover text-white';
    } else if (bgColor === 'primaryRed') {
      baseClasses += ' bg-primaryRed hover:bg-primaryRedHover text-white';
    } else {
      baseClasses += ` bg-${bgColor}`;
      if (bgColorHover) {
        baseClasses += ` hover:bg-${bgColorHover}`;
      }
    }
    return baseClasses;
  };

  return (
    <button
      type={btnType}
      disabled={showLoader || isDisabled}
      className={getButtonClasses()}
      onClick={btnClicked}
    >
      {!showLoader && IconFirst && (
        <IconFirst style={{ fontSize: `${iconSize}rem` }} htmlColor={iconFirstColor} />
      )}
      {!showLoader && <p className="leading-none">{text}</p>}
      {!showLoader && IconLast && (
        <IconLast style={{ fontSize: `${iconSize}rem` }} htmlColor={iconLastColor} />
      )}
      {showLoader && (
        <CircularProgress size={20} style={{ color: loaderColor }} />
      )}
    </button>
  );
}

